export const DEFAULT_BOARD_DISPLAY_TIME = 1000 * 30

export const RETRIVE_UPDATE_TIME = 1000 * 60 * 5

export const IMAGE_EXPIRY_BUFFER_SECONDS = 60

export const ARTICLE_FETCH_INTERVAL = 1000 * 60 * 60 * 24

export const ARTICLE_INTERVAL = 1000 * 60

export const NEXT_LESSONS_FETCH_INTERVAL = 1000 * 60 * 15

export const NEXT_LESSONS_INTERVAL = 1000 * 15
